import { render } from "./FormularioProfesionalesActualizar.vue?vue&type=template&id=17961dc8&ts=true"
import script from "./FormularioProfesionalesActualizar.vue?vue&type=script&lang=ts"
export * from "./FormularioProfesionalesActualizar.vue?vue&type=script&lang=ts"

import "./FormularioProfesionalesActualizar.vue?vue&type=style&index=0&id=17961dc8&lang=scss"

import exportComponent from "/home/runner/work/IAM-PlanCorresponsables/IAM-PlanCorresponsables/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__